import { ShowFor, Size } from "@brightagency/headstart-common";
import React, { ReactNode } from "react";
import { SortButton } from "../../../atoms/SortButton";
import { CarouselControls } from "../../../molecules/CarouselControls";
import { ViewModes } from "../index";
import { Outer, Actions, ListingCount, SortButtonWrapper } from "./styled";

interface Props {
    listingCount: ReactNode;
    viewMode: ViewModes;
    onViewModeChange: (nextViewMode: ViewModes) => void;
    onLeftClick: () => void;
    onRightClick: () => void;
    canScroll: boolean;
}

export const InfoBar: React.FC<Props> = ({
    listingCount,
    onLeftClick,
    onRightClick,
    canScroll,
}) => {
    return (
        <Outer>
            <ListingCount>{listingCount}</ListingCount>
            <Actions>
                <SortButtonWrapper>
                    <SortButton />
                </SortButtonWrapper>
                {canScroll && (
                    <ShowFor size={Size.large}>
                        <CarouselControls onLeftClick={onLeftClick} onRightClick={onRightClick} />
                    </ShowFor>
                )}
            </Actions>
        </Outer>
    );
};
